import { render } from "./LocalizationPickerWidget.vue?vue&type=template&id=9693f06e&scoped=true"
import script from "./LocalizationPickerWidget.vue?vue&type=script&lang=js"
export * from "./LocalizationPickerWidget.vue?vue&type=script&lang=js"

import "./LocalizationPickerWidget.vue?vue&type=style&index=0&id=9693f06e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9693f06e"]])

export default __exports__